"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineBulkAction = void 0;
var defineBulkAction_1 = require("./defineBulkAction");
Object.defineProperty(exports, "defineBulkAction", { enumerable: true, get: function () { return defineBulkAction_1.defineBulkAction; } });
